export default __webpack_public_path__ + "static/media/brainEveningTag.9326100e.svg";